import React, {Component} from 'react';
import DespatchReferenceList from "./DespatchReferenceList";
import OrderReference from "./OrderReference";
import InternetSales from "./InternetSales";
import SGK from "./SGK";
import Payment from "./Payment";
import CarrierParty from "./CarrierParty";
import TaxRepresentativeParty from "./TaxRepresentativeParty";
import {TabForService} from "../../../helper/enums";
import Costs from "./Costs";
import EBelgeIadePane from "./EBelgeIadePane";
import AdditionalDocuments from "./AdditionalDocuments";
import AdditionalInformation from "./AdditionalInformation";


class InformationPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'SiparisBilgileri',
            error: {},
        };
        this.toggle = this.toggle.bind(this);
    }

    componentWillMount() {
        this.setState({activeTab: this.props.activeTab});
    }

    isIncluded = (tabName) => {
        if (tabName === "SiparisBilgileri") return (!["YOLCUBERABERFATURA", "EBELGE"].includes(this.props.profileId));
        if (tabName === "IrsaliyeBilgileri") return (this.props.profileId !== "YOLCUBERABERFATURA");
        if (tabName === "SGKBilgileri") return (this.props.invoiceTypeCode === "SGK" && this.props.accountingCost !== "DIGER");
        if (tabName === "InternetSatisBilgileri") return (this.props.profileId === "EARSIVFATURA");
        if (tabName === "TasiyiciBilgileri") return ((this.props.profileId === "EARSIVFATURA") && this.props.internetSales);
        if (tabName === "AraciKurumBilgileri") return (this.props.profileId === "YOLCUBERABERFATURA");
        if (tabName === "OdemeBilgileri") return (this.props.profileId === "IHRACAT" || this.props.profileId === "TEMELFATURA" || this.props.profileId === "TICARIFATURA" || this.props.profileId === "KAMU" );
        if (tabName === "Masraflar") return ((this.props.profileId === "HKS" && this.props.invoiceTypeCode === "KOMISYONCU") || this.props.invoiceTypeCode === "HKSKOMISYONCU");
        if (tabName === "IadeBilgileri") return (this.props.profileId === "EBELGE");
        if (tabName === "EkDokumanlar") return (["EARSIVFATURA", "IHRACAT", "TEMELFATURA", "TICARIFATURA", "ENERJI"].includes(this.props.profileId));
        if (tabName === "EkBilgiler") return (["EARSIVFATURA", "KAMU", "TEMELFATURA", "TICARIFATURA", "ENERJI"].includes(this.props.profileId));
        return false;
    };

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({activeTab: tab});
            this.props.activeTabListener(tab);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.error !== nextProps.error) {
            this.setState({error: nextProps.error});
        }

        if (this.props.activeTab !== nextProps.activeTab) {
            this.setState({activeTab: nextProps.activeTab});
        }
    }

    isActiveTab = (tab) => {
        return tab.name === ((TabForService[this.props.invoiceTypeCode === "SGK" ? "SGK" : this.props.profileId]).indexOf(this.state.activeTab) > -1 ? this.state.activeTab : TabForService[this.props.invoiceTypeCode === "SGK" ? "SGK" : this.props.profileId][0]);
    };

    renderTabHeader = (tab) => {
        return (
            <li key={tab.name} className="nav-item">
                <a className={"nav-link " + (this.isActiveTab(tab) ? 'active' : '')}
                   onClick={() => {
                       this.toggle(tab.name);
                   }}
                   data-toggle="tab">{tab.label}</a>
            </li>
        );
    };

    renderTabPane = (tab) => {
        return (
            <div key={tab.name} className={"col-sm-12 tab-pane " + (this.isActiveTab(tab) ? 'active' : '')}>
                {tab.pane}
            </div>
        );
    };

    render() {
        let allTabs = [
            {
                name: 'SiparisBilgileri',
                label: 'Sipariş Bilgileri',
                pane: <OrderReference
                    manual={this.props.manual}
                    isManual={this.props.isManual}
                    listener={this.props.listenerOrderReference}
                    orderReference={this.props.orderReference}
                    errorListener={this.props.errorListener}
                    error={this.props.error}
                    showOrderManagerLineNum={this.props.showOrderManagerLineNum}
                />
            },
            {
                name: 'IrsaliyeBilgileri',
                label: 'İrsaliye Bilgileri',
                pane: <DespatchReferenceList
                    manual={this.props.manual}
                    isManual={this.props.isManual}
                    listener={this.props.listenerDespatchReferences}
                    despatchReferences={this.props.despatchReferences}
                    errorListener={this.props.errorListener}
                    error={this.props.error}
                    profileId={this.props.type}
                    externalCustomer={this.props.externalCustomer}
                />
            },
            {
                name: 'SGKBilgileri',
                label: 'SGK Bilgileri',
                pane: <SGK
                    listener={this.props.listenerSGK}
                    manual={this.props.manual}
                    isManual={this.props.isManual}
                    sgkInfo={this.props.sgkInfo}
                    accountingCost={this.props.accountingCost}
                    errorListener={this.props.errorListener}
                    error={this.props.error}
                />
            },
            {
                name: 'InternetSatisBilgileri',
                label: 'İnternet Satış Bilgileri',
                pane: <InternetSales
                    isManual={this.props.isManual}
                    manual={this.props.manual}
                    listener={this.props.listenerInternetSales}
                    internetSales={this.props.internetSales}
                    saleTypes={this.props.saleTypes}
                    errorListener={this.props.errorListener}
                    error={this.props.error}
                />
            },
            {
                name: 'TasiyiciBilgileri',
                label: 'Taşıyıcı Bilgileri',
                pane: <CarrierParty
                    isManual={this.props.isManual}
                    manual={this.props.manual}
                    listener={this.props.listenerCarrierParty}
                    carrierParty={this.props.carrierParty}
                    errorListener={this.props.errorListener}
                    error={this.props.error}
                />
            },
            {
                name: 'AraciKurumBilgileri',
                label: 'Aracı Kurum Bilgileri',
                pane: <TaxRepresentativeParty
                    isManual={this.props.isManual}
                    manual={this.props.manual}
                    listener={this.props.listenertaxRepresentativeParty}
                    taxRepresentativeParty={this.props.taxRepresentativeParty}
                    errorListener={this.props.errorListener}
                    cities={this.props.cities}
                    error={this.props.error}
                />
            },
            {
                name: 'OdemeBilgileri',
                label: 'Ödeme Bilgileri',
                pane: <Payment
                    key={"payment"}
                    isManual={this.props.isManual}
                    manual={this.props.manual}
                    listener={this.props.listenerPayment}
                    listenerClearPayment={this.props.listenerClearPayment}
                    paymentInfo={this.props.paymentInfo}
                    paymentMeansCodes={this.props.paymentMeansCodes}
                    paymentChannelCodes={this.props.paymentChannelCodes}
                    isKamu={this.props.isKamu}
                    errorListener={this.props.errorListener}
                    error={this.props.error}
                    externalCustomer={this.props.externalCustomer}
                    externalCustomerAddress={this.props.externalCustomerAddress}
                    type={"vocuher"}
                    invoiceTypeCode={this.props.invoiceTypeCode}
                    isGocIdaresi={this.props.isGocIdaresi}
                />
            },
            {
                name: 'Masraflar',
                label: 'Masraf Bilgileri',
                pane: <Costs
                    isManual={this.props.isManual}
                    manual={this.props.manual}
                    listener={this.props.listenerCosts}
                    isKamu={this.props.isKamu}
                    errorListener={this.props.errorListener}
                    error={this.props.error}
                    documentId={this.props.documentId}
                    brokerCosts={this.props.brokerCosts}
                    taxInclusiveAmount={this.props.taxInclusiveAmount}
                    taxExclusiveAmount={this.props.taxExclusiveAmount}
                />
            },
            this.props.documentTypeCode && this.props.documentTypeCode === "IADE" ?
            {
                name: 'IadeBilgileri',
                label: 'İade Bilgileri',
                pane: <EBelgeIadePane
                    manual={this.props.manual}
                    isManual={this.props.isManual}
                    listenerIadeTable={this.props.listenerIadeTable}
                    iadeTables={this.props.iadeTables}
                    errorListener={this.props.errorListener}
                    error={this.props.error}
                    profileId={this.props.profileId}
                    documentTypeCode={this.props.profileId === "EBELGE" ? this.props.documentTypeCode : null}
                />
            } : {name: '', label: ''},
            {
                name: 'EkDokumanlar',
                label: 'Ek Dokümanlar',
                pane: <AdditionalDocuments
                    manual={this.props.manual}
                    isManual={this.props.isManual}
                    listener={this.props.setAdditionalDocument}
                    errorListener={this.props.errorListener}
                    error={this.props.error}
                    additionalDocuments={this.props.additionalDocuments}
                    loadingBank={this.props.loadingBank}
                    invoiceTypeCodes = {this.props.invoiceTypeCode}/>
            },
            {
                name: 'EkBilgiler',
                label: 'Ek Bilgiler',
                pane: <AdditionalInformation
                    manual={this.props.manual}
                    isManual={this.props.isManual}
                    listener={this.props.listenerAdditionalInformation}
                    errorListener={this.props.errorListener}
                    error={this.props.error}
                    profileId={this.props.profileId}
                    additionalInformation={this.props.additionalInformation}
                    invoiceTypeCode={this.props.invoiceTypeCode}
                />
            }
        ];

        return (
            <div className="col-sm-12 row card-nav-tabs card-plain">
                <div className="card-header card-header-danger">
                    <div className="nav-tabs-navigation">
                        <div className="nav-tabs-wrapper">
                            <ul className="nav nav-tabs" data-tabs="tabs">
                                {allTabs.filter(tab => this.isIncluded(tab.name)).map(tab => this.renderTabHeader(tab))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="card-body">
                        <div className="tab-content">
                            {allTabs.filter(this.isActiveTab).map(tab => this.renderTabPane(tab))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default InformationPanel;